import cn from 'classnames'
import React from 'react'
import { Trans } from 'react-i18next'

interface Props {
   privacyPolicyUrl: string
   className?: string
}

const PrivacyPolicy = (props: Props) => {
   const { privacyPolicyUrl, className } = props

   return (
      <p className={cn(className, 'text-sm-medium text-gray-700')}>
         <Trans
            i18nKey={'auth:login.privacyPolicyWithLink'}
            components={{
               link1: (
                  <a
                     id='privacy-policy-btn-login'
                     href={privacyPolicyUrl}
                     className={'text-primary-600'}
                     target='_blank'
                     rel='noreferrer'
                  >
                     {/* this is just a fallback string */}
                     Privacy Policy
                  </a>
               )
            }}
         />
      </p>
   )
}

export default PrivacyPolicy
